var _a;
import * as pdfjs from 'pdfjs-dist';
/**
 * Runtime polyfills loaded once at the player level.
 *
 * pdfjs-dist 5.x calls `Map.prototype.getOrInsertComputed` and `.getOrInsert`
 * (TC39 upsert proposal). These aren't yet shipped in mainstream browsers,
 * so we install lightweight polyfills on Map and WeakMap before pdf.js loads.
 *
 * Also configure `pdfjs-dist` to use our copied worker file and eagerly
 * instantiate a long-lived `PDFWorker`. We reuse this worker for every
 * `getDocument` call — avoids worker spin-up latency on each PDF.
 */
// Built by webpack.worker.config.js (`npm run build:worker`), NOT copied from
// pdfjs-dist. The upstream worker is an ES2022 ES module and does not parse on
// the Chromium 60-75 classroom panels; this one is compiled to the same
// Chrome >= 60 floor as the app bundle and is a classic (non-module) script.
pdfjs.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.js";
// Created lazily the first time it's requested (after polyfills install below).
// Doing it at module top-level keeps BackgroundRenderer.tsx free of worker setup.
var sharedPdfWorker = null;
export function getSharedPdfWorker() {
    if (!sharedPdfWorker) {
        sharedPdfWorker = new pdfjs.PDFWorker();
    }
    return sharedPdfWorker;
}
// Warm the worker as soon as polyfills are installed so the first PDF render
// doesn't pay the worker-spin-up cost.
if (typeof window !== 'undefined') {
    // requestIdleCallback keeps boot-critical work unblocked; falls back to
    // setTimeout for browsers that don't support it yet.
    var warm = function () {
        try {
            getSharedPdfWorker();
        }
        catch (_a) {
            /* no-op — worker will be created on demand if eager init fails */
        }
    };
    var idle = (_a = window.requestIdleCallback) !== null && _a !== void 0 ? _a : (function (cb) { return setTimeout(cb, 0); });
    idle(warm);
}
function installUpsertPolyfills(proto) {
    if (!proto.getOrInsertComputed) {
        proto.getOrInsertComputed = function (key, compute) {
            if (this.has(key))
                return this.get(key);
            var value = compute(key);
            this.set(key, value);
            return value;
        };
    }
    if (!proto.getOrInsert) {
        proto.getOrInsert = function (key, defaultValue) {
            if (this.has(key))
                return this.get(key);
            this.set(key, defaultValue);
            return defaultValue;
        };
    }
}
installUpsertPolyfills(Map.prototype);
installUpsertPolyfills(WeakMap.prototype);
